export default {
  Auth: {
    identityPoolId: process.env.AMAZON_COGNITO_IDENTITY_POOL_ID,
    region: process.env.AMAZON_REGION,
    userPoolId: process.env.AMAZON_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.AMAZON_COGNITO_CLIENT_ID,
    cookieStorage: {
      domain: process.env.ZCRUIT_COOKIE_DOMAIN,
      path: process.env.ZCRUIT_COOKIE_PATH,
      expires: parseInt(process.env.ZCRUIT_COOKIE_EXPIRATION),
      secure: process.env.ZCRUIT_COOKIE_SECURE === 'true',
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/amplify.config.js